import { useStateContext } from 'containers/NewReports/state';
import numeral from 'numeral';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(({ palette }) => ({
  negative: {
    color: palette.amount.negative,
  },
  positive: {
    color: palette.amount.positive,
  },
  zero: {
    color: palette.text.tertiary,
  },
}));

type Props = {
  value: number | null | undefined;
  id?: string;
  expectedSign?: 'POSITIVE' | 'NEGATIVE';
  negativeColor?: boolean;
};

export function formatAsAmount(value: number, hideCents: boolean) {
  return value != null ? numeral(value).format(hideCents ? '$0,00' : '$0,00.00') : null;
}

const AmountCell = (props: Props) => {
  const { value, id, expectedSign } = props;
  const { state } = useStateContext();
  const {
    displayOptions: { hideCents, showExpensesAsNegative },
  } = state;
  const { classes } = useStyles();

  if (value == null) return null;

  let sign = (expectedSign === 'NEGATIVE' || (!expectedSign && value < 0)) && showExpensesAsNegative ? '-' : '';
  if (value < 0 && expectedSign === 'POSITIVE' ? '-' : '') {
    sign = '-';
  } else if (value > 0 && expectedSign === 'NEGATIVE') {
    sign = '+';
  }

  const className =
    value === 0
      ? classes.zero
      : expectedSign === 'NEGATIVE' && value > 0
        ? classes.positive
        : expectedSign === 'POSITIVE' && value < 0
          ? classes.negative
          : '';

  return (
    <div id={id} className={className}>
      {`${sign}${formatAsAmount(Math.abs(value), hideCents)}`}
    </div>
  );
};

export default AmountCell;
